import React from 'react';
import ConstructionLayout from './ConstructionLayout';
import { useTheme } from '../../contexts/ThemeContext';
import { FileText, Download } from 'lucide-react';

export default function ReportsPage() {
  const { isDarkMode } = useTheme();

  const reports = [
    { title: 'Earthwork Volume Analysis Report', date: '24 Aug 2024', type: 'PDF', size: '4.2 MB' },
    { title: 'Stockpile Movement & Inventory Report', date: '24 Aug 2024', type: 'PDF', size: '2.8 MB' },
    { title: 'Safety & Structural Observations Report', date: '24 Aug 2024', type: 'PDF', size: '5.1 MB' },
    { title: 'Progress Assessment & Milestone Audit', date: '24 Aug 2024', type: 'PDF', size: '6.4 MB' },
    { title: 'Full Site Intelligence Executive Summary', date: '24 Aug 2024', type: 'PDF', size: '12.0 MB' },
  ];

  return (
    <ConstructionLayout title="Reports">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '700', color: isDarkMode ? '#F3F4F6' : '#111827', margin: 0 }}>Reports</h2>
          <p style={{ fontSize: '13px', color: isDarkMode ? '#9CA3AF' : '#6B7280', margin: '4px 0 0 0' }}>
            Generated drone survey analytics and compliance reports
          </p>
        </div>

        <div style={{ backgroundColor: isDarkMode ? '#111622' : '#FFFFFF', border: `1px solid ${isDarkMode ? '#1E2433' : '#E5E7EB'}`, borderRadius: '12px', padding: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {reports.map((report, idx) => (
            <div
              key={idx}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '12px 16px',
                borderRadius: '8px',
                backgroundColor: isDarkMode ? '#161B26' : '#F9FAFB',
                border: `1px solid ${isDarkMode ? '#252D3D' : '#E5E7EB'}`,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FileText size={20} color="#0082F8" />
                <div>
                  <div style={{ fontSize: '14px', fontWeight: 600, color: isDarkMode ? '#F3F4F6' : '#111827' }}>{report.title}</div>
                  <div style={{ fontSize: '11px', color: isDarkMode ? '#9CA3AF' : '#6B7280' }}>
                    Generated on {report.date} • {report.type} • {report.size}
                  </div>
                </div>
              </div>

              <button style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '6px', backgroundColor: '#0082F8', border: 'none', color: '#FFF', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
                <Download size={14} /> Download
              </button>
            </div>
          ))}
        </div>
      </div>
    </ConstructionLayout>
  );
}
